
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesReturnLaborGrid extends Serenity.EntityGrid<ECommSalesReturnLaborRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesReturnLabor'; }
        protected getIdProperty() { return ECommSalesReturnLaborRow.idProperty; }
        protected getInsertPermission() { return ECommSalesReturnLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesReturnLaborRow.localTextPrefix; }
        protected getService() { return ECommSalesReturnLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}